import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Alert, Button, Form } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import Dialog from '../../../common/components/Dialog';
import RemoteSubmitButton from '../../../common/components/formControls/RemoteSubmitButton';
import { Input } from '../../../common/components/formControls';
import validators from '../../../common/services/validators';
import ui from '../../../common/services/ui';

const formName = 'settleRefund';

// redux-form compares validators by reference, so they must not be rebuilt on every render
const settlementReferenceValidators = [validators.required, validators.maxLength(255)];

const SettleRefundForm = reduxForm({ form: formName })(withTranslation()(({ error, handleSubmit, refund, t }) =>
	<Form horizontal onSubmit={handleSubmit}>
		{error && <Alert bsStyle='danger'>{error}</Alert>}
		<Alert bsStyle='info'>{t('CancellationCreditNote_MarkAsSettledHelp', { amount: ui.formatAmount(refund.amount) })}</Alert>
		<Field name='settlementReference' component={Input} horizontal required label={t('CancellationCreditNote_SettlementReference')}
			validate={settlementReferenceValidators} />
	</Form>));

// an owed refund has been paid back to the parent in the provider's dashboard
const SettleRefundDialog = ({ show, refund, block, unblock, onConfirm, onCancel, t }) => {
	const config = {
		header: t('CancellationCreditNote_MarkAsSettled'),
		body: refund && <SettleRefundForm onSubmit={onConfirm} refund={refund} />,
		onHide: onCancel,
		footer: [
			<Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>,
			<RemoteSubmitButton key='save' style='primary' formName={formName} label={t('CancellationCreditNote_MarkAsSettled')} />
		]
	};
	return <Dialog config={config} show={show} block={block} unblock={unblock} />;
};

SettleRefundDialog.propTypes = {
	show: PropTypes.bool,
	refund: PropTypes.object,
	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired
};

export default withTranslation()(SettleRefundDialog);
